/* iEnjoy theme sections — shared behaviour. Safe to load more than once.
   Rails, videos, FAQ filter, booking days, form prefill, collection filters,
   pair builder, product gallery/variants/sticky bar, tabs. */
(function () {
  if (window.ieHomeInit) return;
  window.ieHomeInit = true;

  var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  var money = function (cents, currency) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', { style: 'currency', currency: currency || 'CAD', currencyDisplay: 'narrowSymbol' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  var money0 = function (cents, currency) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', { style: 'currency', currency: currency || 'CAD', currencyDisplay: 'narrowSymbol' }).format(Math.round(cents) / 100); }
    catch (e) { return '$' + Math.floor(cents / 100); }
  };

  /* ---------- Clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t.closest('[data-ie-rail-btn]');
    if (btn) {
      var rail = document.getElementById(btn.getAttribute('aria-controls'));
      if (!rail) return;
      var first = rail.firstElementChild;
      var step = first ? first.getBoundingClientRect().width + 16 : 316;
      rail.scrollBy({ left: Number(btn.getAttribute('data-ie-rail-btn')) * step, behavior: 'smooth' });
      return;
    }
    var vid = t.closest('.ie-video');
    if (vid) { var v = vid.querySelector('video'); if (v) { v.muted = !v.muted; if (v.paused) v.play(); } return; }
    var thumb = t.closest('[data-ie-thumb]');
    if (thumb) { showSlide(thumb.closest('[data-ie-pm]'), thumb.getAttribute('data-ie-thumb')); return; }
    var stepBtn = t.closest('[data-ie-slide-step]');
    if (stepBtn) { stepSlide(stepBtn.closest('[data-ie-pm]'), Number(stepBtn.getAttribute('data-ie-slide-step'))); return; }
    var q = t.closest('[data-ie-qty]');
    if (q) { var input = q.parentElement.querySelector('input'); input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(q.getAttribute('data-ie-qty'))); return; }
    if (t.closest('[data-ie-cm-open]')) { t.closest('[data-ie-cm]').classList.add('ie-cm--open'); return; }
    if (t.closest('[data-ie-cm-close]')) { t.closest('[data-ie-cm]').classList.remove('ie-cm--open'); return; }
    var tab = t.closest('[data-ie-tabs] [role="tab"]');
    if (tab) {
      var wrap = tab.closest('[data-ie-tabs]');
      wrap.querySelectorAll('[role="tab"]').forEach(function (b) { b.setAttribute('aria-selected', b === tab ? 'true' : 'false'); });
      wrap.querySelectorAll('[role="tabpanel"]').forEach(function (p) { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
      return;
    }
    var faqCat = t.closest('[data-ie-faq-cat]');
    if (faqCat) {
      var faq = faqCat.closest('[data-ie-faq]');
      faq.querySelectorAll('[data-ie-faq-cat]').forEach(function (b) { b.setAttribute('aria-pressed', b === faqCat ? 'true' : 'false'); });
      filterFaq(faq);
      return;
    }
    var pairAdd = t.closest('[data-ie-pair-add]');
    if (pairAdd) {
      var pair = pairAdd.closest('[data-ie-pair]');
      var items = ['a', 'b'].map(function (k) { var r = pair.querySelector('input[name$="-' + k + '"]:checked'); return r && { id: Number(r.value), quantity: 1 }; }).filter(Boolean);
      pairAdd.disabled = true;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function () { window.location.href = root + 'cart'; })
        .catch(function () { pairAdd.disabled = false; });
    }
  });

  /* ---------- Videos ---------- */
  function startVideos(scope) {
    (scope || document).querySelectorAll('.ie-video video').forEach(function (v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); });
  }

  /* ---------- FAQ ---------- */
  function faqTerm() {
    var inputs = document.querySelectorAll('[data-ie-faq-search]');
    for (var i = 0; i < inputs.length; i++) if (inputs[i].value.trim()) return inputs[i].value.trim().toLowerCase();
    return '';
  }
  function filterFaq(faq) {
    var term = faqTerm();
    var pressed = faq.querySelector('[data-ie-faq-cat][aria-pressed="true"]');
    var cat = pressed ? pressed.getAttribute('data-ie-faq-cat') : 'all';
    var shown = 0;
    faq.querySelectorAll('[data-ie-faq-group]').forEach(function (g) {
      var inCat = cat === 'all' || g.getAttribute('data-ie-faq-group') === cat;
      var visible = 0;
      g.querySelectorAll('[data-ie-faq-q]').forEach(function (d) {
        var match = !term || d.textContent.toLowerCase().indexOf(term) !== -1;
        d.hidden = !(inCat && match);
        if (term && match) d.open = true;
        if (!d.hidden) visible++;
      });
      g.hidden = visible === 0;
      shown += visible;
    });
    faq.querySelectorAll('[data-ie-faq-cat]').forEach(function (b) {
      var c = b.getAttribute('data-ie-faq-cat'), n = 0;
      faq.querySelectorAll(c === 'all' ? '[data-ie-faq-q]' : '[data-ie-faq-group="' + c + '"] [data-ie-faq-q]').forEach(function (d) {
        if (!term || d.textContent.toLowerCase().indexOf(term) !== -1) n++;
      });
      var span = b.querySelector('[data-ie-faq-count]');
      if (span) span.textContent = n;
    });
    var none = faq.querySelector('[data-ie-faq-none]');
    if (none) none.hidden = shown !== 0;
  }
  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-ie-faq-search]')) document.querySelectorAll('[data-ie-faq]').forEach(filterFaq);
  });

  /* ---------- Booking days ---------- */
  function buildDays(scope) {
    (scope || document).querySelectorAll('[data-ie-days]').forEach(function (box) {
      if (box.getAttribute('data-ie-built')) return;
      var count = Number(box.getAttribute('data-ie-days')) || 5;
      var weekends = box.getAttribute('data-ie-weekends') === 'true';
      var d = new Date(); d.setDate(d.getDate() + 1);
      var html = '', i = 0;
      while (i < count) {
        var day = d.getDay();
        if (weekends || (day !== 0 && day !== 6)) {
          var label = d.toLocaleDateString('en-CA', { weekday: 'long', month: 'long', day: 'numeric' });
          html += '<label class="ie-opt"><input type="radio" name="contact[Day]" value="' + label + '"' + (i === 0 ? ' checked' : '') + '><span><small>' +
            d.toLocaleDateString('en-CA', { weekday: 'short' }) + '</small><b>' + d.getDate() + '</b></span></label>';
          i++;
        }
        d.setDate(d.getDate() + 1);
      }
      box.style.gridTemplateColumns = 'repeat(' + Math.min(count, 5) + ', minmax(0, 1fr))';
      box.innerHTML = html;
      box.setAttribute('data-ie-built', '1');
    });
  }

  /* ---------- Contact form prefill: ?subject=...&message=... ---------- */
  function prefill() {
    var p = new URLSearchParams(location.search);
    var subject = p.get('subject'), message = p.get('message');
    if (!subject && !message) return;
    document.querySelectorAll('.ie-form--prefill').forEach(function (f) {
      var sel = f.querySelector('select[name="contact[Subject]"]');
      if (sel && subject) {
        var found = Array.prototype.some.call(sel.options, function (o) { if (o.text === subject) { o.selected = true; return true; } return false; });
        if (!found) sel.add(new Option(subject, subject, true, true), 0);
      }
      var ta = f.querySelector('textarea[name="contact[body]"]');
      if (ta && message && !ta.value) ta.value = message;
    });
  }

  /* ---------- Collection filters + sort ---------- */
  var filterTimer;
  function submitFilters(form) {
    var clean = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== '') clean.append(k, v); });
    window.location.href = form.getAttribute('action') + (clean.toString() ? '?' + clean.toString() : '');
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    var form = t.closest('[data-ie-filters]');
    if (form) { clearTimeout(filterTimer); filterTimer = setTimeout(function () { submitFilters(form); }, t.type === 'number' ? 600 : 50); return; }
    if (t.matches('[data-ie-sort]')) {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', t.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
      return;
    }
    if (t.closest('[data-ie-pair]')) { updatePair(t.closest('[data-ie-pair]')); return; }
    if (t.matches('[data-ie-option]')) updateVariant(t.closest('[data-ie-pm]'));
  });

  /* ---------- Pair builder ---------- */
  function updatePair(pair) {
    var cur = pair.getAttribute('data-currency');
    var months = Number(pair.getAttribute('data-months')) || 12;
    var total = 0, names = [];
    ['a', 'b'].forEach(function (k) {
      var r = pair.querySelector('input[name$="-' + k + '"]:checked');
      if (!r) return;
      var p = Number(r.getAttribute('data-price')) || 0;
      total += p;
      names.push(r.getAttribute('data-title'));
      var img = pair.querySelector('[data-ie-pair-img="' + k + '"]');
      if (img && r.getAttribute('data-img')) img.src = r.getAttribute('data-img');
      var name = pair.querySelector('[data-ie-pair-name="' + k + '"]');
      if (name) name.textContent = r.getAttribute('data-title');
      var price = pair.querySelector('[data-ie-pair-price="' + k + '"]');
      if (price) price.textContent = money(p, cur);
    });
    var tEl = pair.querySelector('[data-ie-pair-total]');
    if (tEl) tEl.textContent = money(total, cur);
    var mEl = pair.querySelector('[data-ie-pair-monthly]');
    if (mEl) mEl.textContent = money0(Math.ceil(total / months), cur);
    var q = pair.querySelector('[data-ie-pair-quote]');
    var base = pair.getAttribute('data-quote-url');
    if (q && base) {
      q.href = base + (base.indexOf('?') === -1 ? '?' : '&') + 'subject=' + encodeURIComponent('Best price quote') +
        '&message=' + encodeURIComponent('Pair price request: ' + names.join(' + ') + ' (online total ' + money(total, cur) + ')');
    }
  }

  /* ---------- Product page ---------- */
  function slides(pm) { return Array.prototype.slice.call(pm.querySelectorAll('[data-ie-slide]')); }
  function showSlide(pm, id) {
    if (!pm) return;
    slides(pm).forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-ie-slide') === String(id)); });
    pm.querySelectorAll('[data-ie-thumb]').forEach(function (b) { b.setAttribute('aria-current', b.getAttribute('data-ie-thumb') === String(id) ? 'true' : 'false'); });
  }
  function stepSlide(pm, dir) {
    var all = slides(pm);
    var i = all.findIndex(function (s) { return s.classList.contains('is-active'); });
    var next = all[(i + dir + all.length) % all.length];
    if (next) showSlide(pm, next.getAttribute('data-ie-slide'));
  }
  function updateVariant(pm) {
    if (!pm) return;
    var json = pm.querySelector('[data-ie-variants]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var chosen = [];
    pm.querySelectorAll('[data-ie-option]:checked').forEach(function (r) { chosen[Number(r.getAttribute('data-ie-option'))] = r.value; });
    var v = variants.find(function (x) { return x.options.every(function (o, i) { return chosen[i] === undefined || chosen[i] === o; }); });
    if (!v) return;
    var cur = pm.getAttribute('data-currency');
    var months = Number(pm.getAttribute('data-months')) || 12;
    pm.querySelectorAll('[data-ie-variant-id]').forEach(function (i) { i.value = v.id; });
    pm.querySelectorAll('[data-ie-price]').forEach(function (el) { el.textContent = money(v.price, cur); });
    pm.querySelectorAll('[data-ie-monthly]').forEach(function (el) { el.textContent = money0(Math.ceil(v.price / months), cur) + (pm.getAttribute('data-t-mo') || '/mo'); });
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    pm.querySelectorAll('[data-ie-compare]').forEach(function (el) { el.hidden = !onSale; if (onSale) el.textContent = money(v.compare_at_price, cur); });
    pm.querySelectorAll('[data-ie-save-pill]').forEach(function (el) { el.hidden = !onSale; if (onSale) el.textContent = (pm.getAttribute('data-t-save') || 'Save') + ' ' + money0(v.compare_at_price - v.price, cur); });
    pm.querySelectorAll('[data-ie-sku]').forEach(function (el) { if (v.sku) el.textContent = el.textContent.split(' ')[0] + ' ' + v.sku; });
    pm.querySelectorAll('[data-ie-atc]').forEach(function (b) { b.disabled = !v.available; b.textContent = v.available ? b.getAttribute('data-label') : b.getAttribute('data-soldout'); });
    if (v.featured_media) showSlide(pm, v.featured_media.id);
    var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
  }
  function stickyBars() {
    if (!('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-ie-pm]').forEach(function (pm) {
      var bar = pm.querySelector('[data-ie-sticky]');
      var box = pm.querySelector('[data-ie-buybox]');
      if (!bar || !box || bar.getAttribute('data-ie-watch')) return;
      bar.setAttribute('data-ie-watch', '1');
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        var past = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      }).observe(box);
    });
  }

  function init(scope) {
    startVideos(scope);
    buildDays(scope);
    prefill();
    document.querySelectorAll('[data-ie-faq]').forEach(filterFaq);
    document.querySelectorAll('[data-ie-pair]').forEach(updatePair);
    stickyBars();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Shopify Inbox chat: icon-only round button on phones so it doesn't cover content. */
(function () {
  if (window.__ieChatTamed) return; window.__ieChatTamed = true;
  var CSS = '@media (max-width: 749px){' +
    '.activator__label{display:none!important}' +
    '.activator{width:46px!important;height:46px!important;min-width:0!important;padding:0!important;border-radius:50%!important;justify-content:center!important;gap:0!important}' +
    '.activator svg{margin:0!important}}';
  function tame(root, depth) {
    if (!root || depth > 4) return false;
    var hit = false;
    if (root.querySelector && root.querySelector('.activator, [part="activator"]') && !root.querySelector('style[data-ie-chat]')) {
      var st = document.createElement('style'); st.setAttribute('data-ie-chat', ''); st.textContent = CSS;
      (root.appendChild ? root : root.host).appendChild(st); hit = true;
    }
    var els = root.querySelectorAll ? root.querySelectorAll('*') : [];
    for (var i = 0; i < els.length; i++) if (els[i].shadowRoot && tame(els[i].shadowRoot, depth + 1)) hit = true;
    return hit;
  }
  var tries = 0;
  var t = setInterval(function () {
    tries++;
    var host = document.querySelector('shopify-chat, inbox-online-store-chat');
    if ((host && host.shadowRoot && tame(host.shadowRoot, 0)) || tries > 40) clearInterval(t);
  }, 500);
})();
